import { Component, OnInit } from '@angular/core';
import { StoreService } from 'app/ngrx/store.service';
import { Company } from 'app/modules/models/company.type';
import { MatDialog } from '@angular/material/dialog';
import { PartnersService } from 'app/shared/services/partners.service';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { AcepActeur } from 'app/modules/models/acepActeur.type';
import { AddressAutocompleteComponent } from 'app/shared/address-autucomplete/address-autucomplete.component';
import { AddressFeature, FeatureCollection } from 'app/modules/models/stateAdress.type';
import { BuildingService } from 'app/modules/customer-details/building/building.service';
import { debounceTime } from 'rxjs';
import { CreationProjetService } from './creation-projet.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { formatName } from 'app/shared/utils';
@Component({
  selector: 'app-creation-projet',
  templateUrl: './creation-projet.component.html',
  styleUrls: ['./creation-projet.component.scss']
})
export class CreationProjetComponent implements OnInit {
  cards = [
    'Devis',
    'Autres justificatifs (CDC, Etude de dimensionnement, etc.)'
  ];

  combinedFiles: { files: File[]; card: string }[] = [];

  isUploading = false;

  // Entities
  company: Company;
  project: any;

  // Partners
  partner: any;
  selectedPartnerByMandate: any;
  selectedMandataire: any;
  partnersList: AcepActeur[];
  partnersCtrl = new FormControl();

  // Project form
  projectForm: FormGroup;

  // Map-related data
  options: FeatureCollection;
  filteredOptions: FeatureCollection;

  constructor(
    private readonly _storeService: StoreService,
    private readonly _partnerService: PartnersService,
    private readonly _dialog: MatDialog,
    private readonly _fb: FormBuilder,
    private readonly _buildingService: BuildingService,
    private readonly _creationProjetService: CreationProjetService,
    private readonly _snackBar: MatSnackBar
  ) {
    this.projectForm = this._fb.group({
      rs: [''],
      nom: [''],
      prenom: [''],
      email: [''],
      tel: [''],
      dateEngagement: [''],
      dateTravauxPrevisionnelle: [''],
      adresse: [''],
      cp: [''],
      ville: [''],
      complement: [''],
    });
  }


  ngOnInit(): void {
    this.company = this._storeService.getCurrentCompany();
    this.partner = this._storeService.getUserPartner();
    this.selectedMandataire = localStorage.getItem('currentMandataire_localstorage') ? JSON.parse(localStorage.getItem('currentMandataire_localstorage')) : null;
    this.selectedPartnerByMandate = localStorage.getItem('currentPartner_localstorage') ? JSON.parse(localStorage.getItem('currentPartner_localstorage')) : null;
    if (this.selectedMandataire) {
      this.getPartnersByMandate()
    }
  }

  onViewFile(card: any): void {
    if (card.file) {
      const fileURL = URL.createObjectURL(card.file);
      window.open(fileURL, '_blank');
    } else {
      alert(`Aucun fichier sélectionné pour "${card.label}".`);
    }
  }

  onFileDeleted(event: { file: File, card: string }) {
    const { file, card } = event;
    const index = this.combinedFiles.findIndex(f => f.card === card);

    if (index > -1) {
      this.combinedFiles[index].files = this.combinedFiles[index].files.filter(f => f !== file);

      // If no files remain, remove the entry entirely
      if (this.combinedFiles[index].files.length === 0) {
        this.combinedFiles.splice(index, 1);
      }
    }
  }


  onFileSelected(event: { files: File[], card: string }) {
    const { files, card } = event;
    const isMultiFile = card === 'Autres justificatifs (CDC, Etude de dimensionnement, etc.)';

    const index = this.combinedFiles.findIndex(f => f.card === card);

    if (isMultiFile) {
      if (index > -1) {
        // Avoid duplicates by checking file names
        const existing = this.combinedFiles[index].files.map(f => f.name);
        const newFiles = files.filter(f => !existing.includes(f.name));
        this.combinedFiles[index].files.push(...newFiles);
      } else {
        this.combinedFiles.push({ card, files: [...files] });
      }
    } else {
      // For single-file cards, always replace with the first file
      if (index > -1) {
        this.combinedFiles[index].files = [files[0]];
      } else {
        this.combinedFiles.push({ card, files: [files[0]] });
      }
    }
  }



  deposeProjectFinancement() {
    if (this.isUploadDisabled()) return;

    this.isUploading = true;
    const formData = new FormData();

    this.combinedFiles.forEach(entry => {
      const { card, files } = entry;

      files.forEach((file, index) => {
        const name = file.name;
        const contentType = file.type;
        const extension = name.split('.').pop() || '';

        switch (card) {
          case 'Devis':
            formData.append('DevisFile.BlobFile', file);
            formData.append('DevisFile.Name', name);
            formData.append('DevisFile.ContentType', contentType);
            formData.append('DevisFile.Extension', extension);
            break;
          case 'Autres justificatifs (CDC, Etude de dimensionnement, etc.)':
            formData.append(`OtherFiles[${index}].BlobFile`, file);
            formData.append(`OtherFiles[${index}].Name`, file.name);
            formData.append(`OtherFiles[${index}].ContentType`, file.type);
            formData.append(`OtherFiles[${index}].Extension`, file.name.split('.').pop());
            break;
        }
      });
    });

    var company = this.company;
    var partnerId = this.partner && this.partner?.guidId ? this.partner?.guidId : (this.partner?.id ? this.partner?.id : this.selectedPartnerByMandate?.id);
    var mandateId = this.selectedMandataire ? this.selectedMandataire.id : null;
    var partnerName = this.selectedPartnerByMandate ? this.selectedPartnerByMandate.name : this.partner?.nom;
    var mandateName = this.selectedMandataire ? this.selectedMandataire.name : null;

    this.saveProject(company, partnerId, mandateId, formData, partnerName, mandateName, this.projectForm);
  }


  getSingleFileCard(): { files: File[], card: string }[] {
    const cardOrder = ['Devis'];

    return this.combinedFiles
      .filter(f => f.card !== 'Autres justificatifs (CDC, Etude de dimensionnement, etc.)')
      .sort((a, b) => {
        const indexA = cardOrder.indexOf(a.card);
        const indexB = cardOrder.indexOf(b.card);
        return indexA - indexB;
      });

  }

  getMultipleFileCard(): { files: File[], card: string }[] {
    return this.combinedFiles.filter(f => f.card == "Autres justificatifs (CDC, Etude de dimensionnement, etc.)");
  }

  isUploadDisabled(): boolean {
    const requiredCards = ['Devis'];

    return requiredCards.some(requiredCard => {
      const found = this.combinedFiles.find(f => f.card === requiredCard);
      return !found || found.files.length === 0;
    });
  }

  getPartnersByMandate() {
    this._partnerService.getPartnersByMandate(this.selectedMandataire.id).subscribe(partners => {
      this.partnersList = partners;
      if (this.selectedPartnerByMandate) {
        this.partnersCtrl.setValue(this.partnersList.find(p => p.id === this.selectedPartnerByMandate.id));
      }
    });
  }

  onPartnerSelected(event: any) {
    if (event?.value) {
      this.selectedPartnerByMandate = event.value;
    }
  }

  showAdressAutocomplete() {
    let dialog = this._dialog.open(AddressAutocompleteComponent, {
      width: '600px',
      data: this.options,
    });

    dialog.afterClosed().subscribe((result: any) => {
      if (result) {
        this.splitAddress(result.option.value);
      }
    });
  }

  subscribeToAddressChanges() {
    this.projectForm.get('address').valueChanges.pipe(debounceTime(1000)).subscribe(value => {
      if (value !== null && value !== undefined && value !== '') {
        this._buildingService.getAddress(value).subscribe((result: FeatureCollection) => {
          this.options = result;
          this.filteredOptions = this.options;
        });
      }
    });
  }

  splitAddress(mainAddress: AddressFeature) {
    if (mainAddress) {
      let zipCode = mainAddress.properties.postcode;
      let name = mainAddress?.properties?.name ? mainAddress.properties.name : "";
      let town: string = mainAddress?.properties?.city || mainAddress.properties.district || "";

      this.projectForm.get('adresse')?.setValue(name);
      this.projectForm.get('ville')?.setValue(town);
      this.projectForm.get('cp')?.setValue(zipCode);
    }
  }

  selectedOption(event: any) {
    const selectedAddress: AddressFeature = event.option.value;
    this.splitAddress(selectedAddress);
  }

  saveProject(company: any, partnerId: any, mandateId: any, formData: any, partnerName: any, mandateName: any, projectFormValue: FormGroup) {
    projectFormValue.get('nom')!.setValue(
      formatName(projectFormValue.get('nom')?.value)
    );

    projectFormValue.get('prenom')!.setValue(
      formatName(projectFormValue.get('prenom')?.value)
    );

    projectFormValue.get('email').setValue(projectFormValue.get('email').value?.trim());
    projectFormValue.get('tel').setValue(projectFormValue.get('tel').value?.trim());
    projectFormValue.get('rs').setValue(projectFormValue.get('rs').value?.trim());
    formData.append('ProjectFinancementBeneficiaireInfo', projectFormValue.value ? JSON.stringify(projectFormValue.value) : '');

    this._creationProjetService.depotProjectFinancement(
      company.id,
      partnerId,
      formData,
      mandateId,
      partnerName,
      mandateName
    ).subscribe({
      next: res => {
        this.project = res;
        this.resetAll();
        this._snackBar.open(`Votre projet a bien été créé avec la référence : ${res.projectReference}`, null, { duration: 2000, panelClass: 'accent-snackbar' });
      },
      error: err => {
        this._snackBar.open('Erreur lors de la création. Veuillez réessayer', null, { duration: 2000, panelClass: 'warn-snackbar' });
        this.isUploading = false;
      },
    });
  }

  // Method to reset form, files, and partners
  resetAll() {
    // Reset form
    this.projectForm.reset();
    // Clear uploaded files
    this.combinedFiles = [];
    this.isUploading = false;
  }
}
